export var LinkVariants;
(function (LinkVariants) {
    LinkVariants["link_1"] = "link_1";
    LinkVariants["link_2"] = "link_2";
    LinkVariants["link_3"] = "link_3";
})(LinkVariants || (LinkVariants = {}));
export var LinkWeights;
(function (LinkWeights) {
    LinkWeights["regular"] = "regular";
    LinkWeights["bold"] = "bold";
})(LinkWeights || (LinkWeights = {}));
//# sourceMappingURL=constants.js.map